import { Grid, csx } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'

import { enforce, test } from 'vest'
import { ValidationFn, useFormValidation } from '../../../providers'
import { DatePicker, TimePicker } from '../DateTime'

interface Props {
  names: {
    start: string
    end: string
  }
}

function validateFunction(
  startFieldname: string,
  endFieldname: string
): ValidationFn<[Date, Date]> {
  return function ([start, end], { intl: { formatMessage } }) {
    test(
      startFieldname,
      formatMessage({ id: 'admin/promotions.form.validation.required' }),
      () => {
        enforce(start).isNotNullish()
      }
    )

    test(
      endFieldname,
      formatMessage({ id: 'admin/promotions.form.validation.required' }),
      () => {
        enforce(end).isNotNullish()
      }
    )

    test(
      endFieldname,
      formatMessage({
        id: 'admin/promotions.form.validation.end-before-begin',
      }),
      () => {
        enforce(end.valueOf()).greaterThan(start.valueOf())
      }
    )

    test(
      endFieldname,
      formatMessage({
        id: 'admin/promotions.form.validation.end-before-now',
      }),
      () => {
        enforce(end.valueOf()).greaterThan(new Date().valueOf())
      }
    )
  }
}

export function Scheduling(props: Props) {
  const { names } = props
  const { formatMessage } = useIntl()

  useFormValidation<[Date, Date]>('promotion-scheduling', {
    fieldName: [names.start, names.end],
    validateFn: validateFunction(names.start, names.end),
  })

  return (
    <>
      <Grid templateColumns="1fr 1fr" className={csx({ gap: '$space-4' })}>
        <DatePicker
          label={formatMessage({
            id: 'admin/promotions.form.scheduling.start-date',
          })}
          name={names.start}
        />

        <TimePicker
          label={formatMessage({
            id: 'admin/promotions.form.scheduling.start-time',
          })}
          name={names.start}
        />
      </Grid>

      <Grid templateColumns="1fr 1fr" className={csx({ gap: '$space-4' })}>
        <DatePicker
          label={formatMessage({
            id: 'admin/promotions.form.scheduling.end-date',
          })}
          name={names.end}
        />

        <TimePicker
          label={formatMessage({
            id: 'admin/promotions.form.scheduling.end-time',
          })}
          name={names.end}
        />
      </Grid>
    </>
  )
}
